import Server from '../../api/server'
import { DEVICE_FLEET_STATS_ROUTE, RISK_STATS_ROUTE } from '../../strings/api-consts'
import { FleetStat, RiskStats } from '../../types/DeviceTypes'
import { CustomThunkDispatch } from '../../types/UserTypes'
import { reportErrorToDatadog } from '../../utils/error-logging'
import { initialState, setFleetStat, setDashboardLastUpdated, setRiskStats } from './stats.slice'

const server = new Server()

export const fetchDeviceFleetStats = () => async (dispatch: CustomThunkDispatch) => {
  server
    .get(DEVICE_FLEET_STATS_ROUTE, dispatch)
    .then((fleetStats: FleetStat) => {
      dispatch(setFleetStat(fleetStats ?? initialState.dashboardFleetStat))
      dispatch(setDashboardLastUpdated(fleetStats.createdAt))
    })
    .catch((err) => {
      dispatch(setFleetStat(initialState.dashboardFleetStat))
      dispatch(setDashboardLastUpdated(initialState.dashboardFleetStat?.createdAt))
      reportErrorToDatadog(err.message)
    })
}

export const fetchRiskStats = () => async (dispatch: CustomThunkDispatch) => {
  server
    .get(RISK_STATS_ROUTE, dispatch)
    .then((riskStats: RiskStats) => {
      dispatch(setRiskStats(riskStats ?? initialState.dashboardRiskStats))
      dispatch(setDashboardLastUpdated(riskStats.createdAt))
    })
    .catch((err) => {
      dispatch(setRiskStats(initialState.dashboardRiskStats))
      dispatch(setDashboardLastUpdated(initialState.dashboardRiskStats?.createdAt))
      reportErrorToDatadog(err.message)
    })
}
